<template>
    <MobileHead />
    <div class="_swiper">
        <div class="next" @click="swiperInstance.slideNext()">
            <img
                src="@/assets/mobile/slider/arrow.png"
                alt=""
                style="rotate: 180deg"
            />
        </div>
        <swiper
            @swiper="onSwiper"
            @slideChange="onChange"
            :spaceBetween="50"
        >
            <swiper-slide>
                <img src="@/assets/mobile/slider/who.svg" alt="" />
            </swiper-slide>
            <swiper-slide>
                <img src="@/assets/mobile/slider/why.svg" alt="" />
            </swiper-slide>
            <swiper-slide>
                <img src="@/assets/mobile/slider/what.svg" alt="" />
            </swiper-slide>
            <swiper-slide>
                <img src="@/assets/mobile/slider/works.svg" alt="" />
            </swiper-slide>
        </swiper>
        <div class="next" @click="swiperInstance.slidePrev()">
            <img src="@/assets/mobile/slider/arrow.png" alt="" />
        </div>
    </div>
    <Transition>
        <WhoMobile v-if="actTab == 0" key="who" />
        <WhatMobile v-else-if="actTab == 2" key="what" />
        <WhyMobile v-else-if="actTab == 1" key="why" />
        <WorkMobile v-else-if="actTab == 3" key="work" />
    </Transition>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import MobileHead from "@/components/header/MobileHead.vue";
import { computed, ref, watch } from "vue";
import WhoMobile from "./pages/WhoMobile.vue";
import WhatMobile from "./pages/WhatMobile.vue";
import WhyMobile from "./pages/WhyMobile.vue";
import WorkMobile from "./pages/WorkMobile.vue";
import { useStore } from "vuex";
export default {
    components: {
        MobileHead,
        WhatMobile,
        Swiper,
        SwiperSlide,
        WhoMobile,
        WhyMobile,
        WorkMobile,
    },
    setup() {
        const swiperInstance = ref();
        const store = useStore();

        const actTab = computed(() => store.state.activeTab);
        const isSLide = ref(false);
        const onSwiper = (swiper) => {
            swiperInstance.value = swiper;
        };

        const onChange = (swiper) => {
            isSLide.value = true;
            store.state.activeTab = swiper.realIndex;
        };

        watch(actTab, (tab) => {
            swiperInstance.value.slideTo(tab);
        });
        return {
            actTab,
            onChange,
            onSwiper,
            swiperInstance,
        };
    },
};
</script>

<style lang="scss" scoped>
._swiper {
    display: flex;
    align-items: center;
    padding: 0 5px;
    height: 32vh;
}
.swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35vh;
}
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
